var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditOutlineIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6654 5.50004L14.9987 8.83337M11.6654 5.50004L13.5762 3.5892C13.7325 3.43298 13.9444 3.34521 14.1654 3.34521C14.3863 3.34521 14.5983 3.43298 14.7545 3.5892L16.9095 5.7442C17.0658 5.90048 17.1535 6.1124 17.1535 6.33337C17.1535 6.55434 17.0658 6.76626 16.9095 6.92254L14.9987 8.83337M11.6654 5.50004L3.5762 13.5892C3.41991 13.7454 3.33208 13.9574 3.33203 14.1784V16.3334C3.33203 16.5544 3.41983 16.7663 3.57611 16.9226C3.73239 17.0789 3.94435 17.1667 4.16536 17.1667H6.32036C6.54136 17.1667 6.75329 17.0788 6.90953 16.9225L14.9987 8.83337",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutlineIcon);
export default __webpack_public_path__ + "static/media/EditOutlineIcon.9f020ea48d324b3859ad1b0c14a6c3d2.svg";
export { ForwardRef as ReactComponent };